import { createSelector } from "@reduxjs/toolkit";
import { State } from "redux/store";

const state = (state: State) => state.metadata;

export const getSelectedSection = createSelector(state, (state) => {
  return state.selectedSection;
});

export const getShowMislabelsRange = createSelector(state, (state): boolean => {
  return state.showMislabelsRange;
});

export const getShowDuplicatesRange = createSelector(
  state,
  (state): boolean => {
    return state.showDuplicatesRange;
  }
);
